import type { NotificationsSlice } from '../bs/notifications'

/**
 * Croatian overrides for the notification centre and its preferences.
 *
 * Croatian is ijekavica too, so the lines below are vocabulary: *obavijest*
 * where Bosnian says *obavještenje* — feminine, which is why the urgent count
 * declines differently — *što* for *šta*, *spremiti* for *sačuvati*, *stroj*
 * for *mašina*, *odabrati* and *ponovno*.
 *
 * `notifications.high.many` is absent on purpose: "{count} hitnih" is the same
 * word in both, and the parity test rejects a line that repeats its base.
 */
export const notifications: Partial<NotificationsSlice> = {
  'notifications.high.one': '{count} hitna',
  'notifications.high.few': '{count} hitne',

  'notifications.delete': 'Obriši obavijest',
  'notifications.deleted': 'Obavijest je obrisana.',
  'notifications.failed': 'Nije uspjelo. Pokušajte ponovno.',

  'notifications.viewAll': 'Sve obavijesti',
  'notifications.settings': 'Postavke obavijesti',

  'notifications.filter.label': 'Vrsta obavijesti',
  'notifications.unreadOnly': 'Samo nepročitane',

  'notifications.empty.sve.title': 'Još nema obavijesti',
  'notifications.empty.unread': 'Novu obavijest vidjet ćete ovdje i na zvoncu.',
  'notifications.empty.filter.title': 'Nema obavijesti ove vrste',
  'notifications.empty.5s':
    'Ovdje stiže podsjetnik kad strojevi u vašim pogonima ovog mjeseca još nemaju 5S ocjenu.',
  'notifications.choose': 'Odaberite što primate',

  'notifications.prefs.title': 'Obavijesti',
  'notifications.prefs.intro': 'Odaberite što primate i gdje. Svaka se promjena sprema odmah.',
  'notifications.prefs.noEmail':
    'Za e-poštu najprije upišite svoju adresu u dijelu „Kontakt".',
  'notifications.prefs.dailySummary':
    'Svako jutro u 7 sati: što je novo i što kasni u vašim pogonima — samo kad ima nešto za reći.',
  'notifications.prefs.saved': 'Spremljeno: {type}',
  'notifications.prefs.failed': 'Promjena nije spremljena. Pokušajte ponovno.',
  'notifications.prefs.none': 'Za vašu ulogu nema obavijesti koje se mogu prilagoditi.',
}
